import { render, staticRenderFns } from "./ClientDeals.vue?vue&type=template&id=3fd86b8e"
import script from "./ClientDeals.vue?vue&type=script&lang=js"
export * from "./ClientDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports